// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MapCreate } from "./MapCreate";
import {
  MapCreateFromJSON,
  MapCreateFromJSONTyped,
  MapCreateToJSON,
  MapCreateToJSONTyped,
} from "./MapCreate";
import type { PublicationVersionFileReference } from "./PublicationVersionFileReference";
import {
  PublicationVersionFileReferenceFromJSON,
  PublicationVersionFileReferenceFromJSONTyped,
  PublicationVersionFileReferenceToJSON,
  PublicationVersionFileReferenceToJSONTyped,
} from "./PublicationVersionFileReference";

/**
 *
 * @export
 * @interface PublicationVersionCreate
 */
export interface PublicationVersionCreate {
  /**
   *
   */
  version: number;
  /**
   *
   */
  files?: Array<PublicationVersionFileReference>;
  /**
   *
   */
  maps?: Array<MapCreate>;
}

/**
 * Check if a given object implements the PublicationVersionCreate interface.
 */
export function instanceOfPublicationVersionCreate(
  value: object
): value is PublicationVersionCreate {
  if (!("version" in value) || value["version"] === undefined) return false;
  return true;
}

export function PublicationVersionCreateFromJSON(json: any): PublicationVersionCreate {
  return PublicationVersionCreateFromJSONTyped(json, false);
}

export function PublicationVersionCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionCreate {
  if (json == null) {
    return json;
  }
  return {
    version: json["version"],
    files:
      json["files"] == null
        ? undefined
        : (json["files"] as Array<any>).map(PublicationVersionFileReferenceFromJSON),
    maps: json["maps"] == null ? undefined : (json["maps"] as Array<any>).map(MapCreateFromJSON),
  };
}

export function PublicationVersionCreateToJSON(json: any): PublicationVersionCreate {
  return PublicationVersionCreateToJSONTyped(json, false);
}

export function PublicationVersionCreateToJSONTyped(
  value?: PublicationVersionCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value["version"],
    files:
      value["files"] == null
        ? undefined
        : (value["files"] as Array<any>).map(PublicationVersionFileReferenceToJSON),
    maps: value["maps"] == null ? undefined : (value["maps"] as Array<any>).map(MapCreateToJSON),
  };
}
